<template>
  <div id="BAHome">
    <div class="main">
      <div
        v-for="(item, index) in featureList"
        :key="index"
      >
        <div class="title">
          {{ item.Title }}
        </div>
        <el-row :gutters="20">
          <el-col
            v-for="(feature, feature_index) in item.Data"
            :key="feature_index"
            :span="6"
          >
            <div
              v-if="filterFeatureShow(feature.FeatureName)"
              class="featureBlock"
              @click="handleGoPage(feature)"
            >
              <span>{{ feature.Caption }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <dialog-visitor ref="dialogVisitor" />
    <fast-active ref="FastActive" />
  </div>
</template>
<script>
import dialogVisitor from '@/components/DialogVisitor'
import FastActive from '@/components/FastActive'
export default {
  components: {
    'dialog-visitor': dialogVisitor,
    'fast-active': FastActive
  },
  data () {
    return {
      bannerList: [],
      featureList: [],
      swiperOption: {
        autoplay: {
          delay: 5000
        },
        spaceBetween: 40,
        slidesPerView: 'auto',
        centeredSlides: true
      },
      userInfo: JSON.parse(localStorage.getItem('loginUserInfo')),
      crossCommunityClockAuth: null // 開啟新版跨案場打卡
    }
  },
  async mounted () {
    this.getCommunityClockAuth()
    this.getList()
  },
  methods: {
    async getList () {
      axios(`${process.env.VUE_APP_SBS_URL}/api/Communities/SelectItemsOfHomePage`, {
        method: 'GET',
        headers: { KingnetAuth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}` }
      }).then(res => {
        this.featureList = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    // 判斷是否開啟跨案場打卡
    getCommunityClockAuth () {
      apiAttendanceManagement.GetCommunityClockAuth().then(res => {
        if (res.status === 200) {
          this.crossCommunityClockAuth = res.data.Data.IsOpenCrossCommunityClock
        }
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
      })
    },
    filterFeatureShow (featureName) {
      switch (featureName) {
      case 'visitorManagement': // 訪客管理(新版訪客)
        return this.$isServiceEnabled(17)
      case 'visitorInManagement': // 訪客登記(舊版訪客)
      case 'visitorOutManagement': // 訪客離開(舊版訪客)
        return this.$isServiceEnabled(50)
      case 'attendanceManagement': // 差勤管理
        return this.$isServiceEnabled(4)
      case 'employeeManagement': // 工作人員管理
        if (this.$isServiceEnabled(4)) {
          return !(this.crossCommunityClockAuth && !this.$isServiceEnabled(9))
        } else {
          return this.$isServiceEnabled(9)
        }
      case 'accountManagement': // 社區帳號管理
        return this.userInfo.IsFromEip || this.userInfo.IsAuthorizationAccount
      default:
        return true
      }
    },
    handleGoPage (feature) {
      const goPage = (name) => {
        if (name === 'visitorLeave') {
          this.$refs.dialogVisitor.fastLeave()
        } else if (name === 'openTablet') {
          this.$refs.FastActive.faseActive()
        } else if (name === 'PlusGuestReservation') {
          this.$router.push({ name: 'PlusGuestReservation', params: { guestId: 'List' } })
        } else if (name === 'serviceManager') {
          // 差勤管理有新舊版，分別在 MGMT 與 Housekeeper
          // 資料源統一說明是 MGMT 功能，但這個是 Housekeeper 的路徑，故需要做特殊處理
          this.$toPage(name)
        } else if (feature.IsMgmt) {
          this.$router.push({ name })
        } else {
          this.$toPage(name)
        }
      }
      switch (feature.FeatureName) {
      case 'porpertyManagement': // 資產管理
        goPage('assetList')
        break
      case 'communityRegulations': // 規約辦法
        goPage('Rules')
        break
      case 'accountActivation': // 住戶開通
        goPage('openTablet')
        break
      case 'facilitieBooking': // 公設預約
        goPage('reservation_v2')
        break
      case 'pointManagement': // 點數管理
        goPage('pointManage')
        break
      case 'communityBulletin': // 社區公告
        goPage('news')
        break
      case 'postalManagement': // 郵務管理
        goPage('postal')
        break
      case 'patrolManagement': // 巡邏管理
        goPage('patrolAdministrate')
        break
      case 'communityVoting': // 社區投票
        if (feature.IsMgmt) {
          goPage('voteList')
        } else {
          goPage('vote')
        }
        break
      case 'visitorManagement': // 訪客管理(新版訪客)
        goPage('PlusGuestReservation')
        break
      case 'visitorInManagement': // 訪客登記(舊版訪客)
        goPage('CommunityGuestControl')
        break
      case 'visitorOutManagement': // 訪客離開(舊版訪客)
        goPage('visitorLeave')
        break
      case 'communityNotification': // 推播通知
        goPage('communityPushNotification_v2')
        break
      case 'communityFeedback': // 意見反映
        goPage('message')
        break
      case 'itemsDepositing': // 寄放物品
        goPage('collectionPayment_v2')
        break
      case 'permissionSetting': // 管委服務權限設定
        goPage('CommitteeMain')
        break
      case 'manufacturerManagement': // 廠商管理
        if (feature.IsMgmt) {
          goPage('supplierList')
        } else {
          goPage('serviceStores')
        }
        break
      case 'attendanceManagement': // 差勤管理
        if (this.crossCommunityClockAuth) {
          goPage('AttendanceManagement')
        } else {
          goPage('serviceManager')
        }
        break
      case 'employeeManagement': // 工作人員管理
        if (this.$isServiceEnabled(4) && this.crossCommunityClockAuth) {
          goPage('patrolAdministrate')
          localStorage.setItem('PatrolPersonnelManagement', true)
        } else {
          goPage('staffAdministrate')
        }
        break
      case 'accountManagement': // 社區帳號管理
        goPage('accountList')
        break
      case 'centralMonitoring': // 中央監控系統
        this.goto(feature.Url)
        break
      case 'alarmManagement': // 告警管理
        goPage('baEvent')
        break
      case 'digitalSignage': // 電子看板
        goPage('BulletinIndex')
        break
      case 'communityIntercom': // 社區對講機
        goPage('callRecordList')
        break
      case 'communityStore': // 周邊店家
        goPage('serviceStores_v2')
        break
      case 'gasMeter': // 瓦斯抄表
        goPage('CommunityGas')
        break
      case 'assetItemManagement': // 資產項目管理
        goPage('assetItem')
        break
      case 'communityCalendar': // 社區行事曆
        goPage('Calendar')
        break
      case 'managementFee': // 管理費
        goPage('KGIFeePeriodList')
        break
      case 'propertyManagement': // 產權資料
        goPage('householdProperty')
        break
      }
    },
    goto (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="sass" scoped>
#BAHome
  .main
    width: 960px
    margin: 30px auto
    .title
      margin: 10px
      padding: 5px 10px
      border-left: 5px solid $mainColor
      font-size: 20px
    .featureBlock
      height: 100px
      margin: 10px 15px
      padding: 15px
      box-sizing: border-box
      display: flex
      justify-content: center
      align-items: center
      font-size: 30px
      color: #5f5f5f
      background-color: #fff
      box-shadow: 3px 3px 7px -1px #aaa
      border-radius: 6px
      cursor: pointer
      &:hover
        background-color: $whiteHover
</style>
